/*global angular*/
'use strict';

/**
 * A restaurant could have one or no active promotion (`active_promotion`).
 * The `active_promotion.type` can be 1 of 5:
 *   `FREE_DELIVERY`
 *   `DISCOUNTED_DELIVERY`
 *   `CONDITIONAL_FREE_DELIVERY`
 *   `FOOD_PERCENTAGE_OFF`
 *   `CONDITIONAL_FOOD_PERCENTAGE_OFF`
 *   `FOOD_AMOUNT_OFF`
 *   `CONDITIONAL_FOOD_AMOUNT_OFF`
 * 
 * 
 * Subtotal and Total always show. Other amounts show depending on these scenarios:
 *  `FREE DELIVERY` => active promotion (type == `FREE_DELIVERY` || (type == `CONDITIONAL_FREE_DELIVERY` && calculated delivery fee == 0))
 *  (red)`SERVICE FEE` => active promotion type == `DISCOUNTED_DELIVERY`
 *  `Service Fee`
 */

angular.module('MrDWebApp')
  .controller('CartCtrl', function($scope, $rootScope, $cookies, storage, $http, $filter, orderFactory, $state, $previousState, $window) {

    var _cart = this;

    _cart.showExclusionNotes = !!window.config.show_exclusion_notes;

    $scope._rc.bodyClass = 'html-cart';

    $scope._rc.track('cart_page','view_cart');

    $previousState.memo('caller');

    $scope.notes = 'asf';

    _cart.isWorking = false;
    _cart.ready = false;
    _cart.ready_reason = '';

    _cart.delivery_label = 'Mr D Delivery';
    _cart.collect_label = 'Self Collect';

    _cart.deliveryClass = '';
    _cart.collectClass = '';

    // console.log('$scope._rc.variables.restaurant.id: '+$scope._rc.variables);
    // console.log(JSON.stringify($scope._rc.variables));
    if(!$scope._rc.variables.restaurant.id){ // No saved Restaurant?
      $state.go('confirm-address');
    }

    $scope._rc.cart.totals.delivery_fee = $scope._rc.variables.restaurant.delivery_fee;

    $scope.$on('cart:modified', function (event, input) {
      _cart.checkReady();
    });

    $scope.promo = $scope._rc.variables.restaurant.active_promotion;

    if($scope._rc.variables.restaurant.delivery_option === 'delivery'){
      _cart.delivery_label = 'Mr D Delivery only';
      _cart.collect_label = 'Self collect';
      _cart.deliveryClass = 'active';
      _cart.collectClass = 'disabled';
      $scope._rc.cart.type = 'delivery';
    }

    if($scope._rc.variables.restaurant.delivery_option === 'collect'){
      _cart.delivery_label = 'Mr D Delivery';
      _cart.collect_label = 'Self collect only';
      _cart.deliveryClass = 'disabled';
      _cart.collectClass = 'active';
      $scope._rc.cart.type = 'collect';
    }

    if($scope._rc.variables.restaurant.delivery_option === 'collect_and_delivery'){
      _cart.deliveryClass = 'active';
      _cart.collectClass = '';
      if($scope._rc.cart.type === 'collect') {
        _cart.deliveryClass = '';
        _cart.collectClass = 'active';
      }
      if($scope._rc.cart.type === 'delivery') {
        _cart.deliveryClass = 'active';
        _cart.collectClass = '';
      }
    }

    _cart.getAddonPrice = function(addon, addonGroup, item) {
      //var price = window.getAddonGroupSubTotal(addonGroup.items.mop('price'), addonGroup.price_modifier, item.price);
      var price = addon.price; //default
      var selected = addon;
      switch (addonGroup.price_modifier) {
        case 'SUM_PRICES': return price;
        case 'DELTA_PRICES': console.log('delta', addon.price, ' - ', item.price); return Math.max(0, addon.price - item.price);

        case 'HIGHEST_PRICE': {
          addonGroup.items.forEach(function(a){
            if (a.price > price) { // a.price is higher - select it
              price = a.price;
              selected = a;
            }
          });
        } break;
        case 'LOWEST_PRICE': {
          addonGroup.items.forEach(function(a){
            if (a.price < price) { // a.price is lower - select it
              price = a.price;
              selected = a;
            }
          });
        } break;
      }

      if (addon === selected) {
        return price;
      } else {
        return 0;
      }
    };

    _cart.deliveryClick = function(){
      if($scope._rc.variables.restaurant.delivery_option !== 'delivery' &&
        $scope._rc.variables.restaurant.delivery_option !== 'collect_and_delivery') {
        return false;
      }
      $scope._rc.cart.type = 'delivery';
      _cart.deliveryClass = 'active';
      _cart.collectClass = '';
      $scope._rc.cart.totals.delivery_fee = $scope._rc.variables.restaurant.delivery_fee;
      _cart.checkReady();
      $scope._rc.total_calc_no_return();

    };

    _cart.collectClick = function(){
      if($scope._rc.variables.restaurant.delivery_option !== 'collect' &&
        $scope._rc.variables.restaurant.delivery_option !== 'collect_and_delivery') {
        return false;
      }
      $scope._rc.cart.type = 'collect';
      _cart.deliveryClass = '';
      _cart.collectClass = 'active';

      $scope._rc.cart.totals.delivery_fee = 0;

      _cart.checkReady();
      $scope._rc.total_calc_no_return();
    };

    _cart.discount = function(item){
      return 0;
    };

    //Temp Shit
    $scope._rc.cart.customer.id = $scope._rc.access.user.id;

    _cart.checkReady = function(){

      var check = true;
      $scope._rc.total_calc_no_return();

      if(typeof $scope._rc.cart.items === 'undefined'){
        check = false;
      } else if($scope._rc.cart.items.length === 0){

        check = false;
        _cart.ready_reason = 'No items in cart...';

      } else {

        if($scope._rc.cart.type === 'collect') {
          //Pretty Flat. We're cool with that...
          check = true;
        }
        else if($scope._rc.cart.type === 'delivery') {
          if ($scope._rc.cart.totals.local_subtotal < $scope._rc.variables.restaurant.min_order_value) {
            // Order Value too small...
            check = false;
            _cart.ready_reason = 'Your order is below the min order value';
          } else {
            check = true;
          }
          if (check) {
            // Delivery.. but you might have a collect item...
            for (var i = 0; i < $scope._rc.cart.items.length; i += 1) {
              if ($scope._rc.cart.items[i].collect_only === true &&
                check) {
                check = false;
                _cart.ready_reason = 'Looks like you have collect only items in your delivery cart.';
              }
            }
          }
        }
      }

      if(check){
        _cart.ready = true;
        _cart.ready_reason = '';
      } else {
//         console.log('final not ready');
        _cart.ready = false;
      }
    };

    _cart.removeItem = function(item){
      var index = $scope._rc.cart.items.indexOf(item);
      if(index > -1) {
        $scope._rc.cart.items.splice(index, 1);
        $scope._rc.resetCartAge();
        $rootScope.$broadcast('cart:modified');
        storage.set('mrd-web-cart', $scope._rc.cart);
      }
      _cart.checkReady();
    };

    _cart.removeOpExAd = function(options,option){
      var index = options.indexOf(option);
      if(index > -1) {
        options.splice(index, 1);
        $rootScope.$broadcast('cart:modified');
        storage.set('mrd-web-cart', $scope._rc.cart);
      }
      _cart.checkReady();
    };

    _cart.warnOrInitiate = function(){
      if (!$scope._rc.cart.items || !$scope._rc.cart.items.length) {
        _cart.ready = false;
        _cart.ready_reason = 'No items in cart...';
      } else if ($scope._rc.cart.type === 'collect'){
        $rootScope.$broadcast('global_message:show',{
          'name': 'self_collect_warning',
          'for_state': 'cart',
          'title': 'Self Collection!',
          'error' : {
            'friendly_message': 'Just checking that you know you will need to collect your order?'
          },
          'confirm' : {
            'label': 'I understand',
            'action': 'action',
            'value': true,
            'value_object': _cart
          },
          'deny' : {
            'label': 'Cancel',
            'action': 'close',
            'value': true,
            'value_object': null
          }
        });
      } else {
        $scope._rc.track('checkout','begin_checkout'); //BUTTON CLICK
        $window._adjustEvent('7jorbv'); //tap_checkout_in_cart
  
        // Delivery Order... continue as normal
        _cart.initiateOrder();
      }
    };

    _cart.initiateOrder = function(){

      // VALIDATE EXCLUSION NOTES
      
      var strRegex = window.config.exclusion_notes_regex;
      if (strRegex) {
        var regex = new RegExp(strRegex,'g');
        var m;
        var isNoGo = false;
        var testGroup = function(match, groupIndex) {
          //console.log(`Found match, group ${groupIndex}: ${match}`);
          if (groupIndex === 1 && !match) isNoGo = true;
        };
        while ((m = regex.exec($scope._rc.cart.restaurant.order_notes)) !== null) {
            // This is necessary to avoid infinite loops with zero-width matches
            if (m.index === regex.lastIndex) {
              regex.lastIndex++;
            }
            
            // The result can be accessed through the `m`-variable.
            m.forEach(testGroup);
        }
        if (isNoGo) {
          _cart.notesInvalid = true;
          return;
        }

      }


      _cart.isWorking = true;

      delete $scope._rc.cart.fresh; // Sanitize

      // if($scope._rc.cart.invoice_number){ // The order you're working with exists....
      //
      // } else {
      //   console.log('this order does not exit exists - no invpoice number on cart');
      //   //$scope._rc.pre_cart = angular.copy($scope._rc.cart);
      // }

      /* Cleaning Order before Re-posting */

      // Delete existing orders stuff...
      $scope._rc.cart.status = 'new';
      var temp_totals = angular.copy($scope._rc.cart.totals);
      $scope._rc.cart.totals = angular.copy($scope._rc.cart_template.totals);
      //$scope._rc.cart.totals.total = temp_totals.total; Would want to do this... but throws ugly validation error...
      // $scope._rc.cart.totals.local_subtotal = temp_totals.subtotal;
      $scope._rc.cart.totals.delivery_fee = temp_totals.delivery_fee;

      delete $scope._rc.cart.id;
      delete $scope._rc.cart.cloud_hub_driver;
      delete $scope._rc.cart.loyalty_programs;
      delete $scope._rc.cart.invoice_number;
      delete $scope._rc.cart.customer_vat;
      delete $scope._rc.cart._created_at;
      delete $scope._rc.cart._updated_at;
      delete $scope._rc.cart.delivery;
      delete $scope._rc.cart.discounts;
      delete $scope._rc.cart.failure_details;
      delete $scope._rc.cart.machine_learning_results;
      //delete $scope._rc.cart.validation_failures;


      // Payment Type
      delete $scope._rc.cart.payment;
      $scope._rc.cart.payment = {};

      // Fix Restaurant
      var res = $scope._rc.cart.restaurant;
      var restaurant_id = res.id;
      var menu_id = ($scope._rc.cart.menu && $scope._rc.cart.menu.id) ? $scope._rc.cart.menu.id : res.menu_id;
      var notes = res.order_notes;
      var active_meal_deal = res.active_meal_deal;
      var active_buy_1_get_1_free = res.active_buy_1_get_1_free;

      delete $scope._rc.cart.restaurant;
      $scope._rc.cart.restaurant = {
        id : restaurant_id,
        menu_id: menu_id,
        order_notes: notes,
        active_meal_deal: active_meal_deal,
        active_buy_1_get_1_free: active_buy_1_get_1_free,
      };

      //Fix Customer
      var save_customer = {};
      save_customer.id = $scope._rc.cart.customer.id;

      save_customer.address = {
        province: $scope._rc.cart.customer.address.province,
        street_name: $scope._rc.cart.customer.address.street_name,
        longitude:$scope._rc.cart.customer.address.longitude,
        suburb: $scope._rc.cart.customer.address.suburb,
        postal_code: $scope._rc.cart.customer.address.postal_code,
        latitude: $scope._rc.cart.customer.address.latitude
      };

      if( $scope._rc.cart.customer.address.building_type){
        save_customer.address.building_type =  $scope._rc.cart.customer.address.building_type;
      }
      if( $scope._rc.cart.customer.address.complex){
        save_customer.address.complex =  $scope._rc.cart.customer.address.complex;
      }
      if( $scope._rc.cart.customer.address.label){
        save_customer.address.label =  $scope._rc.cart.customer.address.label;
      }

      delete $scope._rc.cart.customer;
      $scope._rc.cart.customer = angular.copy(save_customer);


      /**
       * ADDON PRICE HACK FIX...
       */
      var hackedDummyCart = angular.copy($scope._rc.cart);
      delete hackedDummyCart.verification;

      // wipe additional fees off cart that gets posted to server as server validation fails,
      // but keep it on session cart as we need it to display on review details page, shew..
      if (hackedDummyCart.additional_fees !== undefined){
        hackedDummyCart.additional_fees = undefined;
      }

      angular.forEach(hackedDummyCart.items,function(item) {
        // console.log("BASE PRICE:", item.price);

        var baseCost = item.price;
        var additionalCost = 0;
        if (item.addonGroups) item.addonGroups.forEach(function(addonGroup){
          // first get the sum of options and extras
          additionalCost += addonGroup.items.reduce(function(total,item){
            if (item.extras && item.extras.length) total+= item.extras.reduce(function(extrasTotal,option){return extrasTotal + option.price;},0);
            if (item.options && item.options.length) total+= item.options.reduce(function(optionsTotal,option){return optionsTotal + option.price;},0);
            return total;
          },0);

          //add addon price
          baseCost += window.getAddonGroupSubTotal(addonGroup.items.mop('price'), addonGroup.price_modifier, item.price);
        });
        if (item.quantityFree) {
          var increments = item.quantityPay + item.quantityFree;
          var payFactor = item.quantityPay / increments;
          item.price = baseCost * payFactor;
        } else {
          item.price = baseCost;
        }

        item.price += additionalCost;
        // delete item.quantityFree; // server does not seem to complain if we don't remove these
        // delete item.quantityPay;

        delete item.modifiers;
      });

      $scope._rc.setOrderSource(hackedDummyCart); //attempt to fix the stale months old order sources

      orderFactory.save({userID:$scope._rc.access.user.id}, hackedDummyCart,
        function success(response) {

          // Test Response
          // response.error = {
          //   friendly_message : 'Delivery No Longer Available',
          //   developer_message : 'Delivery No Longer Available',
          //   http_response_code : 403
          // };

          // @todo we know there is an error, can't be sure it's "delivery no longer available"
          // Not response.data.error
          //console.log('success');
          if(response.error || (response.data && response.data.error)) {

            _cart.onSaveCartFail(response);
            //console.log('success failure');
            

          } else {

            delete response.$promise;
            delete response.$resolved;

            //console.log('CART>>>', JSON.stringify($scope._rc.cart));
            //console.log('SERVER>>>', JSON.stringify(response));

            // response.items.forEach(function(item){
            //   if (item.old_price) {
            //     item.new_price = item.price;
            //     item.price = item.old_price;
            //     delete item.old_price;
            //   }
            // });

            //YAY
            var yay = false;
            var ad = hackedDummyCart.customer.address;
            var cart = Object.assign({}, hackedDummyCart);
            cart.customer = Object.assign({}, cart.customer);
            cart.customer.address = Object.assign({}, cart.customer.address);
            cart.customer.address.geo_location = {lat:parseFloat(ad.latitude), lon:parseFloat(ad.longitude)};
            cart.delivery_options = {delivery_type:cart.type};
            if (yay) $http.post(window.env.apiURL + 'quotations', cart, {bypassErrorHandler:true})
            .then(function(res){
              if (Math.round(cart.totals.local_subtotal*100) === Math.round(res.data.quote.subtotal*100)) return true;
              console.log('#'+response.id, '- client:', cart.totals.local_subtotal, '- server:', res.data.quote.subtotal);
              window.Raven.captureMessage(['I','m','ba','lance'].join(''), {level:'warning'});
            })
            .catch(function(er){
              return true;
            });
            //END OF YAY

            delete response.items;
            /* GW: changed from `extend` (shallow copy) to `merge` (deep copy) so that values ommitted on the response don't get lost */
            angular.merge( $scope._rc.cart, response);
            if (response.menu && response.menu.id) {
              $scope._rc.cart.restaurant.menu_id = response.menu.id;
            }

            /* Analytics */ $scope._rc.trackCheckoutSuccess();

            $rootScope.$broadcast('cart:modified');
            storage.set('mrd-web-cart',$scope._rc.cart);

            $state.go('checkout',{orderID:$scope._rc.cart.id, userID:$scope._rc.access.user.id});

          }

        },
        function err(response) {

          // SENTRY
          try {
            var er = response.data.error;
            if (er) {
              console.warn('Cart Checkout.', er.developer_message, er.error_code);
              if ((er.error_code === 'VALIDATION_ERRORS') && er.friendly_message) console.warn(er.friendly_message);
              window.Raven.captureMessage('Cart Checkout.', Object.assign({level:'warning'},er.developer_message));
            }
          } catch (error) {
            console.warn('Could not report error.', error);
          }

          //GW: the following few lines is to handle the failures on the order limit validation - the group (Sven, John, Carl, Nigel and I) decided that no order error should be fatal to the order process
          _cart.onSaveCartFail(response.data);//{error:{friendly_message:'',developer_message:''}}

          //a lot of code was remove to satisfy the 'unreachable code' rule - check commit history

        });
    };
    
    _cart.onSaveCartFail = function(response){
      var message = 'Something went wrong...';
      var dev_message = 'Something Went Wrong';
      if(response.error && response.error.friendly_message && response.error.developer_message){
        dev_message = response.error.developer_message;
        message = response.error.friendly_message;
      } else if(response.data && response.data.error && response.data.error.friendly_message && response.data.error.developer_message){
        dev_message = response.data.error.developer_message;
        message = response.data.error.friendly_message;
      }
      /* Analytics */ $scope._rc.trackCheckoutFailure(dev_message);

      $rootScope.$broadcast('global_message:show',  {
        'name': 'select_other_restaurant',
        'for_state' : 'cart',
        'error' : {
          'friendly_message': message
        },
        'confirm' : {
          'label': 'Try Again',
          'action' : 'retry',
          'value' : 'cart',
          'value_object': {}
        },
        'deny' : {
          'label': 'Change Restaurant',
          'action' : 'redirect',
          'value' : 'location',
          'value_object': $scope._rc.variables
        }
      });
      _cart.isWorking = false;
    };

    _cart.increment = function(direction,item){
      var inc = item.quantityFree + item.quantityPay;
      if(direction === 'up' && item.quantity < 99){
        item.quantity += inc;
        $scope._rc.resetCartAge();
      }
      if(direction === 'down' && item.quantity > inc){
        item.quantity -= inc;
        $scope._rc.resetCartAge();
      }
      _cart.checkReady();
    };


    _cart.checkReady(); // Initial Check

  });
